"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import ItemShop from "@/components/virtual-shop/elements/item-shop/ItemShop.vue";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import { Component, PropSync, Mixins } from "vue-property-decorator";
const activeicon = require("@/assets/style/icon/activeIcon.png");
let ColumnOperate = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.activeIcon = activeicon;
  }
  onActive() {
    return __async(this, null, function* () {
      try {
        let version_response = yield API.get(`api://base.local/update/version`);
        if (version_response.data.os.name.toLowerCase() === "windows") {
          yield API.put(`api://base.local/v2/dynamic-browsers/${this._column.shopOldId}`);
        } else {
          yield API.post(`api://base.local/websockets/extension_${this._column.shopOldId}`, {
            model: "browser.active",
            value: {
              "message": "browser.active"
            }
          });
        }
      } catch (error) {
      }
    });
  }
};
__decorateClass([
  PropSync("column")
], ColumnOperate.prototype, "_column", 2);
ColumnOperate = __decorateClass([
  Component({
    components: {
      ItemShop
    }
  })
], ColumnOperate);
export {
  ColumnOperate as default
};
